module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Bold.d4ed1329.eot";